// CmcUsageWidget/CmcUsageProgressBar.jsx
// Pure painter — linear progress bar. Not a sentiment-scale like FearGreedMeterBar,
// so a simple filled track fits better than a blocks-meter.
import React from 'react';

/**
 * @param {{pct:number,color:string}} props
 */
const CmcUsageProgressBar = ({ pct, color }) => {
    const width = Math.max(0, Math.min(100, pct));

    return (
        <div className="cuw-progress-track">
            <div className="cuw-progress-fill" style={{ width: `${width}%`, backgroundColor: color }} />
        </div>
    );
};

export default CmcUsageProgressBar;
